// extracted by mini-css-extract-plugin
module.exports = {"root":"MediaLink_root__83kCQ"};